module.exports = __webpack_public_path__ + "assets/img/infinite_official_account.3ecb1209.jpg";